<template>
    <div>
      <div>
        <div class="form-group">
          <label for="stage">{{ $t('Select a stage') }}</label>
          <select id="stage" v-model="stageSelected" class="form-control">
            <option :value="null">-----</option>
            <option v-for="stage in stages" :key="stage.id" :value="stage">
              {{ stage.name }}
              ({{ dayjs(stage.start_at).format('L') + ' '  + dayjs(stage.start_at).format('LT') }} ->
                {{ dayjs(stage.end_at).format('L') + ' '  + dayjs(stage.end_at).format('LT') }})
            </option>
          </select>
        </div>
      </div>
      <hr>
        <Stage v-if="stageSelected"
           :slot-resource-url="slotResourceUrl"
           :stage="stageSelected"
           :zone="zone"
           @slot-added="addSlot($event, stageSelected)"
           @slots-updated="updateSlots($event, stageSelected)"
        >
        </Stage>
    </div>
</template>

<script>
    import Stage from './Stage.vue'
    import dayjs from "dayjs";
    export default {
      computed: {
        dayjs() {
          return dayjs
        }
      },
        components: {
            Stage,
        },
        props: {
            slotResourceUrl: {
                type: String,
                required: true,
            },
            zone: {
                default: 'UTC'
            },
            stages: {
                type: Array,
                default: []
            },
        },
        data () {
            return {
                stagesCollection: [],
                stageSelected : null,
            }
        },
        methods: {
            addSlot(slot, stage) {
                var stageIndex = _.findIndex(this.stagesCollection, {
                    id: stage.id
                });

                this.stagesCollection[stageIndex].booking_slots = [
                  ... this.stagesCollection[stageIndex].booking_slots,
                  slot
                ].sort((a, b) => {
                  const dateA = dayjs(a.start_at);
                  const dateB = dayjs(b.start_at);
                  return dateA - dateB;
                });
                this.stageSelected = this.stagesCollection[stageIndex];
            },
            updateSlots(slots, stage) {
                var stageIndex = _.findIndex(this.stagesCollection, {
                    id: stage.id
                });
                this.stagesCollection[stageIndex].booking_slots = slots;
                this.stageSelected = this.stagesCollection[stageIndex];
            }
        },
        mounted () {
            this.stagesCollection = _.clone(this.stages, true);
        }
    }
</script>

<style scoped>

</style>